import { formatName } from '../../utils/helpers';
import { useContext } from 'react';
import { MembershipAppStateContext } from '../MembershipAppState/MembershipAppState';
import { PartnerEnrollments } from '../../application/models/NewJoinSessionData';
import { Stack, Typography } from '@ace-clublabs/shared-component-library';
import { FlowType } from '@ace-clublabs/common-membership-api-types';
import gift_confirmation_image from '../../assets/gift-confirmation-image.svg';
import { IPartnerIntegration } from '@lib/types';

type PartnerTitleProps = {
  availableOffers: IPartnerIntegration[] | null | undefined;
  partnerEnrollments: PartnerEnrollments;
};

const PartnerTitle = ({ availableOffers, partnerEnrollments }: PartnerTitleProps) => {
  const newAccountEnrollment = availableOffers?.some(
    (integration) => partnerEnrollments[integration.name] && !integration.hasExistingAccount
  );

  const NewEnrollmentTitle = <>Complete your enrollment to enjoy your exclusive AAA benefits</>;

  if (newAccountEnrollment) {
    return NewEnrollmentTitle;
  }

  return <>Start enjoying your exclusive AAA benefits</>;
};

export const ConfirmationTitle = () => {
  const { sessionData } = useContext(MembershipAppStateContext);

  const partnerOffers = sessionData.partnerOffers;
  const partnerEnrollments = sessionData.formData.partnerEnrollments || ({} as PartnerEnrollments);

  const isGiftFlow = sessionData.flowType === FlowType.GIFT;
  const donorEmail = sessionData.formData.giftDetails?.donor?.email;
  const isMajorRocketFlow = sessionData.flowType === FlowType.MAJOR_ROCKET;
  const isGrouponFlow = sessionData.flowType === FlowType.GROUPON;
  const completeRegistration = sessionData.completedRegistration;
  const confirmationInfo = sessionData.confirmationData;

  return (
    <Typography variant="h5" className="confirm-header">
      {isGiftFlow ? (
        <Stack>
          <img src={gift_confirmation_image} className="gift-confirmation-image"></img>
          <Typography variant="h5" className="gift-confirmation-title">
            Thank you for your purchase
          </Typography>
          <Typography variant="b1Regular" className="gift-confirmation-send-email qm-mask">
            We've sent an email confirmation to <strong>{donorEmail}</strong>.
          </Typography>
        </Stack>
      ) : isMajorRocketFlow || isGrouponFlow || !completeRegistration ? (
        <>Welcome to AAA, {formatName(confirmationInfo?.firstName ?? '')}!</>
      ) : (
        <PartnerTitle availableOffers={partnerOffers?.availableOffers} partnerEnrollments={partnerEnrollments} />
      )}
    </Typography>
  );
};
